<!-- Sin eventos no hay bloque: ni marco, ni título, ni CTA, ni hueco. -->
@if (shouldRender()) {
  <section class="block-eventos">
    <div class="block-eventos__inner">
      <header class="block-eventos__header">
        <h2 class="block-eventos__title">{{ copy.upcomingTitle }}</h2>
        <a class="block-eventos__cta" routerLink="/eventos">{{ copy.upcomingCta }}</a>
      </header>

      <div class="block-eventos__list">
        <!-- La portada es global: aquí el chip sí identifica el juego. -->
        @for (event of events(); track event.id) {
          <app-event-card [event]="event" [showGame]="true" />
        }
      </div>
    </div>
  </section>
}
